import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  background: ${({ theme }) => theme.colors.white};

  gap: 24px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  & > button {
    flex: 1;
  }
`;
